/*
 * Package: WebVideo.SiteUtils
 * Copyright (c) 2017 Sergey Leonov
 */

function SiteUtils() {}

SiteUtils.updateAccountBalance = function(amount) {
  $(".ac-balance-amount").html(
    StringUtils.formatDouble(amount, 2)
  );
};

SiteUtils.getAccountBalance = function() {
  var balance_str = $("#ac-balance-amount").text().replace(/ /g, "");
  return parseFloat(balance_str);
};

SiteUtils.modifyAccountBalance = function(amount) {
  SiteUtils.updateAccountBalance(
    SiteUtils.getAccountBalance() + amount
  );
};

SiteUtils.reduceAccountBalance = function(amount) {
  SiteUtils.modifyAccountBalance(-1 * Math.abs(amount));
};

SiteUtils.increaseAccountBalance = function(amount) {
  SiteUtils.modifyAccountBalance(Math.abs(amount));
};

SiteUtils.updateCustomField = function (key, value, successCallback, errorCallback) {
  $.post(Config.exec + "/_ajaj-webvideo-gateway.jsp?", {
    command: 'upload-cf',
    [key]: value
  }).success(successCallback)
    .error(errorCallback)
};

/*
* deprecated:
*/
accountBalance_updateAmountStr = SiteUtils.updateAccountBalance;
accountBalance_modifyAmountStr = SiteUtils.modifyAccountBalance;
accountBalance_createExpencesByPaidMessage = SiteUtils.reduceAccountBalance;